import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import {  message,Checkbox,Button,Menu, Dropdown,Timeline ,Popover,Collapse,Select,DatePicker,Modal,Input,TimePicker  } from 'antd';
import $ from 'jquery'
import {PlusCircleOutlined,MinusCircleOutlined } from '@ant-design/icons' ;

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import add from '../../assets/images/icon/add.png';
import edit from '../../assets/images/icon/edit.png';
import boy from '../../assets/images/icon/boy.png';
import girl from '../../assets/images/icon/girl.png';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			class_list : [],
			academic_year_list : [],
			class_list : [],
			division_list : [],
			staff_type_list : [],
			staff_list : [],
			visible: false,
			followup: false,
			addfollow: false,
			status_view: false,
			timeline: false,
			group_id: 0,
			subgroup_id: 0,
			section: '',
			class: '',
			division: '',
			sequence: '',
			session_array: [],
			academic_year_: [],
			session: '',
			academic_year: '',
		}
		
		
		this.change_year = this.change_year.bind(this);
		this.change_class = this.change_class.bind(this);
		this.goBack = this.goBack.bind(this);
		this.change_days = this.change_days.bind(this);
		this.onChangeTime = this.onChangeTime.bind(this);
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.change_division = this.change_division.bind(this);
	}
	
	onChangeTime(time, timeString) {
	 this.setState({ start_time: timeString, });
	}
  

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		}
		this.checkData(); 
	}

	handleSession=(e)=>{
		var value = e.target.value;
		var extra = value - 1;
		var people = [];
		var j = 1;
		for (let i = 0; i < value; i++) {		
			var id = j;
			people.push({id:id,name:'',quantity:0});
			j++;
		}	
			
	    setTimeout(() => {  
		this.setState({session_array:people,session:value,extra:extra});	
		}, 500);
		this.checkData(); 
	}
	
		checkData(){
				if(localStorage.getItem('schoolData')){
					var storedArray = JSON.parse(localStorage.getItem("schoolData"));
					var school_id = storedArray['data'][0]['school_id'];
					var user_id = storedArray['data'][0]['user_id'];
					var type = storedArray['data'][0]['type'];
					var app = {school_id : school_id,user_id:user_id,type:type}
					getData('erp/new_program_list',app).then((result) => {
						let responseJson = result;
						if(responseJson.data){
							if(result['status'] == 200){
								this.setState({
									class_list: result['data'],
								});
							}else{
								this.setState({
									class_list: [],
									
								});
							}
						}
					});
					getData('common/get_academic_year',app).then((result) => {
						let responseJson = result;
						if(responseJson.data){
							if(result['status'] == 200){
								this.setState({
									academic_year_: result['data'],
								});
							}else{
								this.setState({
									academic_year_: [],
								});
							}
						}
					});
			}
		  }

	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		
		var session_name = [];
		for (var i = 0; i < this.state.session_array.length; i++) {
			 session_name[i]= document.getElementById('session_'+i).value; 			
		 }	
		
		var period = [];
		for (var i = 0; i < this.state.session_array.length; i++) {
			 period[i]= document.getElementById('period_'+i).value; 			
		 }	
		 
		var duration = [];
		for (var i = 0; i < this.state.session_array.length; i++) {
			 duration[i]= document.getElementById('time_'+i).value; 			
		 }
		 
		var ebreak = [];
		var count = this.state.session_array.length - 1 ;
		for (var i = 0; i < count; i++) {
			 ebreak[i]= document.getElementById('break_'+i).value; 			
		 }	 
		 
		var break_time = [];
		for (var i = 0; i < count; i++) {
			 break_time[i]= document.getElementById('break_time_'+i).value; 			
		 }	 
		
		var app = {
			
			school_id : storedArray['data'][0]['school_id'],
			user_id : storedArray['data'][0]['user_id'],
			academic_year : this.state.academic_year,
			class : this.state.class,
			start_time : this.state.start_time,
			session : this.state.session,
			days : this.state.days,
			division : this.state.division,
			period : period,
			duration : duration,
			session_name : session_name,
			break : ebreak,
			break_time : break_time,
		}
		getData('Timetable/add_timetable',app).then((result) => {
		if(result.status==400){
             message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Timetable Updated',2);
              this.setState({ loading: false });
              this.setState({comment_text:''});
              window.location.href = '/time-table/list';
          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

	}
	
	change_year(event){
         this.setState({academic_year: event});
     }	
	 
	change_days(event){
         this.setState({days: event});
    } 
	 
	change_class(event){
         this.setState({class: event,division_list:[],division:''});
		  var app = {user_id : this.state.user_id,program_id:event,school_id:this.state.school_id}
		 getData('erp/division_list_by_class',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						division_list: result['data'],
					});
				}else{
					this.setState({
						division_list: [],
					});
				}
			}
		});	
     }
	 
	change_division(event){
         this.setState({division: event});
    }
	 
	 change_price() {
		var session        = $('.session').val(); 

	   if(Number(session) > 2){
		 $('#price_err').html('Session cannot be greater 2! ');   
	   }
	   else{
		 $('#price_err').html(''); 
	   }
	  }
	
	handletabchange=(e)=>{
			this.setState({
					tab: e,
				});
			
	}
	
	handleSession=(e)=>{
		var value = e.target.value;
		
		var people = [];
		var j = 1;
		for (let i = 0; i < value; i++) {		
			var id = j;
			people.push({id:id,name:'',quantity:0});
			j++;
		}	
			
	    setTimeout(() => {  
		this.setState({session_array:people,session:value});	
		}, 500);
		 
	}
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
	
	
	
  
	
	goBack() {
		window.location.reload(false);
	 }
  

	render()

	{
	
	const { size } = this.state;
	
					
		return (
			<div class="mobile_view">
			
			
			
			<div class="row bred">
				<div class="col-md-12">
				<div class="card">
				<div class="card-body">
					<h4 class="page-title"> 
						<i class="mdi mdi-apple-keyboard-command title_icon"></i>Add Time Table
						
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item">
									<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
									<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
									</a>
								</li>
								<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/time-table/list`} class="router-link-active" target="_self">Time Table</a> </li>
								<li class="breadcrumb-item"> Add Time Table </li>
							</ol>
						</div>
					</h4>
				</div>
				</div>
				</div>
			</div>
		 	
           
		   <div class="col-md-12 ex-padd view-Profile view-Profile-mobile "> 
		
		   
            <div class="row">
			   <div class="col-md-12 mb-20 card-content mh-500 iq-card">
					<div class="children mb-20 mh-40 iq-card2 form-group">
                    
						<div class="row">
								<div class="col-md-4 col-sm-12  mb-20">
									<label>Select Academic Year</label>
									<Select onChange={this.change_year} value={this.state.academic_year}>
										<Select.Option value="">Select Academic Year</Select.Option>
										{this.state.academic_year_.map((list) => (
											<Select.Option value={list.name}>{list.name}</Select.Option>
										))}
							        </Select>
								</div>
								<div class="col-md-4 col-sm-12  mb-20">
									<label>Select Class</label>
									<Select onChange={this.change_class} value={this.state.class}>
										<Select.Option value="">Select Class</Select.Option>
										{this.state.class_list.map((list)=> (
											<Select.Option value={list.id}>{list.name}</Select.Option>
										))}
									</Select>
								</div>
								<div class="col-md-4 col-sm-12  mb-20">
									<label>Select Division</label>
									<Select onChange={this.change_division} value={this.state.division}>
											<Select.Option value="">Select Division</Select.Option>
											{this.state.division_list.map((list) => (
												<Select.Option value={list.id}>{list.name}</Select.Option>
											))}
									</Select>
								</div>
								
						</div>
						
						
						
						<div class="row">
							<div class="col-md-7 col-sm-12 mb-20 dis-input">
									<label>Select Days</label>
									<Select onChange={this.change_days} allowClear mode="multiple">
										<Select.Option value="Monday">Monday</Select.Option>
										<Select.Option value="Tuesday">Tuesday</Select.Option>
										<Select.Option value="Wednesday">Wednesday</Select.Option>
										<Select.Option value="Thursday">Thursday</Select.Option>
										<Select.Option value="Friday">Friday</Select.Option>
										<Select.Option value="Saturday">Saturday</Select.Option>
									</Select>
								</div>
							<div class="col-md-2 col-sm-12 mb-20 tt">
								<label class="d-block">School start time: </label>
								<TimePicker use12Hours format="h:mm a" onChange={this.onChangeTime} />
							</div>
							
							<div class="col-md-3 col-sm-12 mb-20  session">
								 <label>Select Session </label>
								 <input type="number" name="session"  onChange={this.handleSession.bind(this)} onKeyUp={this.change_price} class="form-control int-only session"  min="0"  max="2" defaultValue="0" />
								 <p class="error" id={`price_err`}></p>
							</div>
							
							{(() => {
							  
							if (this.state.session_array.length > 0) {
							return (
							<>
								<div class="col-md-12 time-div">
											<div class="row">
											<div class="col-md-4 col-sm-4 head">
												<label class="d-block pt-15"><b>Session</b></label>
											</div>
											<div class="col-md-4 col-sm-4 head">
												<label class="d-block pt-15"><b>No of Periods</b></label>
											</div>
											<div class="col-md-4 col-sm-4 head">
												<label class="d-block pt-15"><b>Periods Duration</b></label>
											</div>
											</div>
								</div>
								
							{this.state.session_array.map((list2, data) => (
							<>
								
										<div class="col-md-12 col-sm-12 time-div">
											<div class="row">
											<div class="col-md-4 col-sm-4 bg">
												<label class="d-block pt-15"><b>Session {list2.id}</b></label>
												<input type="hidden" value={list2.id} id={`session_${data}`} />
											</div>
											<div class="col-md-4 col-sm-4 bg">
												<input type="number" class="form-control int-only"  min="1" defaultValue="1" name="period" id={`period_${data}`} required/>
											</div>
											<div class="col-md-4 col-sm-4 bg">
												<div class="row">
												<div class="col-md-8 col-sm-12 no-border">
													<input type="number" class="form-control int-only"  min="1" defaultValue="1" name="time"  id={`time_${data}`}required/>
												</div>
												<div class="col-md-4 col-sm-12 col-sm-12  no-border">
													<span class="pt-15"><b>(In minutes)</b></span>
												</div>
												</div>
												
											</div>
											</div>
										</div>
										
										{(() => {
										if (this.state.session_array.length > list2.id) {
										return (
										<div class="col-md-12 col-sm-12 time-div">
											<div class="row">
											<div class="col-md-4 col-sm-4 break">
												<label class="d-block pt-15"><b>Break  {list2.id}</b></label>
												<input type="hidden" value={list2.id} id={`break_${data}`} />
											</div>
											<div class="col-md-4 col-sm-4 break">
												
											</div>
											<div class="col-md-4 col-sm-4 break">
												<div class="row">
												<div class="col-md-8 col-sm-12 no-border ">
													<input type="number" class="form-control int-only"  min="1" defaultValue="1" name="time"  id={`break_time_${data}`}required/>
												</div>
												<div class="col-md-4 col-sm-12 col-sm-12  no-border ">
													<span class="pt-15"><b>(In minutes)</b></span>
												</div>
												</div>
												
											</div>
											</div>
										</div>
										)
										}
										})()}
							</>
							))}
							</>
							)
							}
							})()}
							
							
							
							
							
							
							
							
						</div>
						
					
					<div class="col col-md-12 s12 meal bt mt-10 pt-10 mb-10 text-center">
						 <Button className="btn btn-primary mr-2" id="submit_btn" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
					</div>
						
					</div> 
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
     
			</div>
		) 
	} 
}
export default Index;
